import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useWindowSize } from "../../../../shared/hooks/useWindowSize";

export default function NumberLocation({ orderNr, map }) {

    const [ size, setSize ] = useState(null);
    const { isMobile, isDesktop } = useWindowSize();

    useEffect(() => {
        if(!isDesktop){
            setSize(35);
        }
        else{
            if (map) {
                setSize(40);
            } else {
                setSize(62);
            }
        }
    }, [map]);

    // Don't render until size is determined
    if (size === null) {
        return null;
    }

    //  return a rounded div with orderNr inside
    return (
        <Box
            className="order-nr-circle"
            sx={{
                backgroundColor: "#003C59",
                height: `${size}px`,
                width: `${size}px`,
                borderRadius: "50%",
                border: "2px solid white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Typography variant="body1" component="span" sx={{ color: 'white', fontWeight: 'bold' }}>
                {orderNr}
            </Typography>
        </Box>
    );
}